<template>
{{ dispValue }}
</template>

<script>
import { DateTime } from 'luxon';
export default {
  props: {
    item: {},
    column: {},
    value: {},
  },
  computed: {
    dispValue() {
      return DateTime.fromFormat(this.value || "", 'yyyy-MM-dd HH:mm:ss').toFormat('dd. MM. yyyy.');
    },
  },
}
</script>
